import React from "react";

const DpiLabel = (props) => {
    return (
        <em className="txt-error">
            Image Size: {props.width} x {props.height} @ {props.dpi} DPI
        </em>
    );
};

export default DpiLabel;
